module.exports = __webpack_public_path__ + "img/estimated_progress_graph.126e27ec.svg";